export const customerUserResourceType = 'customer_user_registration';
export const customerUserResourcePath = '/customer_users';
